import { FREE_INSURANCE_END_DATE } from '../../../../constants';
import { usePriceSuggestionPageTranslation } from '../../../../translation';
import Text from '../../../Text';
import styles from '../../PriceSuggestionSection.module.css';
import PriceBlock from '../PriceBlock';
interface YourPriceProps {
  price: number;
  discountMonthlyPremium?: number;
  isFreeCampaign?: boolean;
}

const YourPrice = ({
  price,
  discountMonthlyPremium = 0,
  isFreeCampaign
}: YourPriceProps) => {
  const t = usePriceSuggestionPageTranslation();
  const discountPrice = discountMonthlyPremium + price;
  const shouldShowDiscount = discountMonthlyPremium > 0;
  const formattedEndDate = new Date(FREE_INSURANCE_END_DATE);
  const endDayAndMonth = `${formattedEndDate.getDate()}/${
    formattedEndDate.getMonth() + 1
  }`;

  return (
    <div className={styles.yourPrice}>
      {shouldShowDiscount ? (
        <>
          <Text type="normal-big">{t('YOUR_PRICE_WITH_DISCOUNT')}</Text>
          <Text type="normal-small" className="line-through">
            {discountPrice.toFixed(0) + 'kr'}
          </Text>
        </>
      ) : (
        <Text type="normal-big">{t('YOUR_PRICE')}</Text>
      )}
      <PriceBlock price={price} />
      <Text type="normal-big" className={styles.priceExplanation}>
        {' '}
        {isFreeCampaign
          ? t('SEJFA_PAYS_FREE_INSURANCE', { endDayAndMonth })
          : t('PAYMENT_FREQUENCY')}
      </Text>
    </div>
  );
};

export default YourPrice;
